import { SxStyleProp } from '@hotelplan/util.theme.sxc';

export const wishlistNameStyles: SxStyleProp = {
  textOverflow: 'ellipsis',
  overflow: 'hidden',
  whiteSpace: 'nowrap',
  flex: '1 1px',
  textAlign: 'left',
};
